export const PARAM_LIST_SEPARATOR = ",";
export const MULTISTOP_IATA_LIST_SEPARATOR = "|";
export const LOCATION_IATA_CODE_AND_TYPE_SEPARATOR = ".";
export const URL_IATA_LIST_SEPARATOR = "_";
export const VALID_TRIP_TYPES = ["ONEWAY", "ROUNDTRIP", "MULTISTOP"];
export const VALID_CABIN_CLASSES = [
    "ECONOMY",
    "PREMIUM_ECONOMY",
    "BUSINESS",
    "PREMIUM_BUSINESS",
    "FIRST",
    "PREMIUM_FIRST"
];
export const MANDATORY_SEARCH_PARAMS_ONEWAY = ["type", "adults", "cabinClass", "from", "to", "depart"];
export const MANDATORY_SEARCH_PARAMS_ROUNDTRIP = ["type", "adults", "cabinClass", "from", "to", "depart", "return"];
export const MANDATORY_SEARCH_PARAMS_MULTISTOP = ["type", "adults", "cabinClass", "from", "to", "multiStopDates"];
export const A11Y_MOBILE_QUERY_PARAMS = "a11y_mobile_view";
